var map = {
	"./_base-breadcrumbs.vue": "80cc",
	"./_base-button-genre.vue": "c9dd",
	"./_base-button-play.vue": "d081",
	"./_base-button.vue": "8339",
	"./_base-card-link.vue": "cfb4",
	"./_base-card.vue": "cb2a",
	"./_base-content.vue": "3182",
	"./_base-custom-select.vue": "86a1",
	"./_base-dots.vue": "4506",
	"./_base-dropdown.vue": "4c80",
	"./_base-empty-list.vue": "cc99",
	"./_base-favourites.vue": "4a1b",
	"./_base-hero-background.vue": "82be",
	"./_base-hero.vue": "fdeb",
	"./_base-icon.vue": "670f",
	"./_base-input.vue": "08ce",
	"./_base-link.vue": "cbd4",
	"./_base-load-more.vue": "6b52",
	"./_base-placeholder.vue": "9300",
	"./_base-resource-cover.vue": "3493",
	"./_base-resource-image.vue": "0611",
	"./_base-search-input.vue": "c640",
	"./_base-section.vue": "be25",
	"./_base-select.vue": "a61f",
	"./_base-spinner.vue": "1603",
	"./_base-tab-list.vue": "5876",
	"./_base-tab-panel.vue": "c15e",
	"./_base-tab.vue": "dd88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b526";